const coin = {
  title: 'عملات ذهبية',
  thisMonthRecharge: 'إعادة الشحن هذا الشهر',
  thisMonthReward: 'مكافأة هذا الشهر',
};

const bean = {
  title: 'فاصوليا',
};

const gem = {
  title: 'جوهرة',
};

const pearl = {
  title: 'لؤلؤة',
};

const list = {
  type: 'type: {{type}}',
};

const coffee = {
  title: 'قهوة',
};

const chart = {
  monday: 'Mon',
  tuesday: 'Tue',
  wednesday: 'Wed',
  thursday: 'Thu',
  friday: 'Fri',
  saturday: 'Sat',
  sunday: 'Sun',
};

export default {
  coin,
  bean,
  gem,
  pearl,
  coffee,
  chart,
  list,
  supporters: 'الداعمون',
  report: 'الإبلاغ',
  detail: 'التفاصيل',
  exchange: 'التبادل',
  recharge: 'إعادة الشحن',
  yesterdayIncome: 'دخل الأمس',
  todayIncome: 'دخل اليوم',
  monthIncome: 'هذا الدخل الشهري',
};
